import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";


function Login() {
  const [formData, setFormData] = useState({ kullanicikodu: "", parola: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  //const server_URL = `http://192.168.2.250:50`;
  useEffect(() => {
    async function checkIfLoggedIn(){
      try{
        const res = await fetch('/me', {credentials: "include"});
        if(res.ok)
        {
          const data = await res.json();
          console.log("Token active. redirecting...");
          console.log(data);
          navigate('/izin_talep');
        }
      }catch(err){
        console.log("Not logged in yet");
      }
    }
    checkIfLoggedIn();
    }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials:'include',
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || "Giriş başarısız");
      }
      console.log(data);
      console.log(response);
      //localStorage.setItem("user", JSON.stringify(data.user)); // Store user info
      //setTimeout(() => {
        console.log("Navigating to izin_talep");
        navigate(`/izin_talep`);
      //}, 1000);
    } catch (err) {
      console.error('Login error:',err.message);
      if(err.message==='no_token'||err.message==='token_expired'||err.message==='invalid_token')
         navigate(`/login`);
      else setError(err.message);
    }
  };

  return (
    <div className="container">
      <img src="/logo.png" alt="Logo" className="logo" />
      <h1>Giriş</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <label>TC Kimlik No</label>
        <input
          type="text"
          value={formData.kullanicikodu}
          onChange={(e) =>
            setFormData({ ...formData, kullanicikodu: e.target.value })
          }
        />
        <label>Parola</label>
        <input
          type="password"
          value={formData.parola}
          onChange={(e) => setFormData({ ...formData, parola: e.target.value })}
        />
        <button type="submit">Giriş</button>
      </form>
    </div>
  );
}

export default Login;
